import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import Theme from 'components/common/Theme/Theme'
import Details from 'components/common/Details/Details'
import Media from 'components/common/Media'

const MainSpecs = ({ specs = [], className }) =>
  <PropertyWrapper className={ className }>
    {
      specs.map(({ specValue, specName, specTip }, num) =>
        <Details key={ num } title={ specName } tooltip={ specTip }>{ specValue }</Details>
      )
    }
  </PropertyWrapper>

export default MainSpecs

MainSpecs.propTypes = {
  className: PropTypes.string,
  specs: PropTypes.arrayOf(PropTypes.object)
}

const PropertyWrapper = styled.dl`
  width: 100%;
  border-top: 1px solid ${Theme.colors.light_grey};
  ${Media.mobile`
    & dd {
      border-right: none;
    }
  `}
`
